import { render } from "./RelevanciesReport.vue?vue&type=template&id=1fdef2e1"
import script from "./RelevanciesReport.vue?vue&type=script&lang=js"
export * from "./RelevanciesReport.vue?vue&type=script&lang=js"

import "./RelevanciesReport.vue?vue&type=style&index=0&id=1fdef2e1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__